import React from 'react';
import './mifid-section.scss';
import { Domanda, Sezione } from 'azshared/build/main/lib/api/generated/dob';
import { UseFormReturn } from 'react-hook-form';
import { SurveyQuestion } from './survey-question';

interface MifidSectionProps {
  section?: Sezione;
  form: UseFormReturn;
  readonly?: boolean;
}

function sort(a: Domanda, b: Domanda) {
  if (a?.numDomanda && b?.numDomanda) {
    // Confronta parte per parte: "4.2.2" -> [4, 2, 2]
    const aParts = a.numDomanda.split('.').map((p) => parseInt(p, 10));
    const bParts = b.numDomanda.split('.').map((p) => parseInt(p, 10));

    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
      const aVal = aParts[i] || 0;
      const bVal = bParts[i] || 0;
      if (aVal !== bVal) return aVal - bVal;
    }
    return 0;
  }
  if (a?.numDomanda && b?.numDomanda) {
    return parseInt(a.numDomanda.split('.').join(''), 10) - parseInt(b.numDomanda.split('.').join(''), 10); // a.numDomanda.localeCompare(b.numDomanda);
  }
  if (a?.numDomanda && b.strutturaInternaDomande?.domande?.[0]?.numDomanda) {
    return a.numDomanda.localeCompare(b.strutturaInternaDomande.domande[0].numDomanda);
  }
  if (b?.numDomanda && a.strutturaInternaDomande?.domande?.[0]?.numDomanda) {
    return a.strutturaInternaDomande.domande[0].numDomanda.localeCompare(b.numDomanda);
  }
  if (a?.numDomanda) {
    return -1;
  }
  if (b?.numDomanda) {
    return 1;
  }
  return (a?.idDomanda ?? 0) - (b?.idDomanda ?? 0);
}

// filtering unused answers
function filter(a: Domanda) {
  return ![a.idDomanda || -1, ...(a.strutturaInternaDomande?.domande?.map((d) => d.idDomanda || -1) || [])]?.some((d) =>
    [263, 264, 265, 125, 126, 127].includes(d)
  );
}

export const MifidSection = ({ section, form, readonly }: MifidSectionProps) => {
  form.watch();

  const shouldHide = (d: Domanda) => {
    if (!d.listaDipendenze?.length) return false;
    const alwaysVisibleIds = [290, 293, 296, 299, 255];
    if (alwaysVisibleIds.includes(d.idDomanda || 0)) return false;
    return d.listaDipendenze.some((dep) => {
      if (dep.tipoDipendenza === 'disable' && dep.idDomandaDipendenza && dep.idRispostaDipendenza) {
        const val = form.getValues(`survey-${dep.idDomandaDipendenza}`);
        if (!val) return true; // Nascondi se non c'è risposta
        const values = (val as string).split(',');
        return values.includes(dep.idRispostaDipendenza.toString());
      }
      return false;
    });
  };

  return (
    <div className='mifid-section'>
      <h3>{section?.descSezione ?? ''}</h3>
      {section?.listaDomande
        ?.filter(filter)
        .filter((d) => !shouldHide(d))
        .sort(sort)
        .map((d) => (
          <>
            {d.pathImage && <img className='mifid-image' alt={'image'} src={d.pathImage} />}
            <SurveyQuestion key={d.idDomanda} form={form} question={d} readonly={readonly} />
          </>
        ))}
    </div>
  );
};
